import style from "components/v3/Listings/ListingFullDisplay/components/ListingMap/styles.module.css";
import { GMAPS_API_KEY_IFRAME } from "Config/GMapsConfig";
import useTranslation from "next-translate/useTranslation";
import { useState } from "react";
import styles from "./contact.module.css";
import ContactForm from "./ContactForm/contactForm";

const contact = () => {
  const { t, lang } = useTranslation("contact");

  const [mapsStyle, setMapsStyle] = useState("roadmap");

  const [twoStyle, setTwoStyle] = useState({
    first: true,
    second: false,
  });

  const handleChangeMap = (value) => {
    setMapsStyle(value);
  };

  return (
    <div className={styles.contact_container}>
      <div className={styles.background_image}>
        <h1 className={styles.title_contact}>{t("Contactez-nous")}</h1>
        <p className={styles.under_title}>
          {t("Nous vous répondrons dans les plus brefs délais")}
        </p>
      </div>
      <div className={styles.contacter_par_container}>
        <div className={styles.par_internet}>
          <div className={styles.svg_contacter_container}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 68 54"
              fill="none"
              className={styles.svg_contacter}
            >
              <path
                d="M61 0.5625H7C3.5845 0.567 0.817 3.3345 0.8125 6.75V47.25C0.817 50.6655 3.5845 53.433 7 53.4375H61C64.4155 53.433 67.183 50.6655 67.1875 47.25V6.75C67.183 3.3345 64.4155 0.567 61 0.5625ZM7 3.9375H61C62.2668 3.94875 63.331 4.806 63.655 5.9715L63.6595 5.99175L34 27.1778L4.3405 5.99175C4.669 4.806 5.7355 3.94875 7 3.9375ZM61 50.0625H7C5.4475 50.0602 4.18975 48.8025 4.1875 47.25V10.0282L33.019 30.6225C33.0505 30.645 33.091 30.636 33.1225 30.6562C33.3655 30.8205 33.6625 30.9217 33.982 30.933H33.9842L33.9955 30.9375H34L34.0112 30.933C34.333 30.9217 34.63 30.8182 34.8798 30.6517L34.873 30.6562C34.9045 30.636 34.945 30.645 34.9765 30.6225L63.808 10.0282V47.25C63.8057 48.8025 62.548 50.0602 60.9955 50.0625H61Z"
                fill="#00B4FF"
              />
            </svg>
          </div>
          <div className={styles.par_internet_infos}>
            <p className={styles.par_internet_infos_title}>{t("Par mail")}</p>
            <p className={styles.par_internet_infos_text}>
              {t(
                "Vous pouvez nous contacter par courriel à l'adresse suivante"
              )}{" "}
              :
            </p>
            <a
              rel="noindex,nofollow, noreferrer"
              className={styles.par_internet_infos_link}
              href="mailto:contact@agenz.ma"
            >
              contact@agenz.ma
            </a>
          </div>
        </div>
        <div className={styles.par_telephone}>
          <div className={styles.svg_contacter_container}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className={styles.svg_phone}
              viewBox="0 0 72 58"
              fill="none"
            >
              <path
                d="M35.9777 0.179863C35.5962 0.185825 35.2328 0.342872 34.967 0.616535C34.7013 0.890199 34.5549 1.25812 34.5602 1.63955V16.0395C34.5575 16.2304 34.5927 16.4198 34.6639 16.5969C34.735 16.774 34.8407 16.9351 34.9747 17.071C35.1086 17.2069 35.2683 17.3148 35.4443 17.3885C35.6204 17.4621 35.8093 17.5001 36.0002 17.5001C36.191 17.5001 36.3799 17.4621 36.556 17.3885C36.732 17.3148 36.8917 17.2069 37.0257 17.071C37.1597 16.9351 37.2653 16.774 37.3365 16.5969C37.4076 16.4198 37.4429 16.2304 37.4402 16.0395V1.63955C37.4428 1.44689 37.4068 1.25567 37.3342 1.07719C37.2616 0.898718 37.1539 0.736627 37.0175 0.600517C36.8811 0.464406 36.7188 0.357044 36.5402 0.284789C36.3616 0.212534 36.1703 0.176854 35.9777 0.179863ZM59.7742 5.44205C59.4915 5.436 59.2132 5.51331 58.9742 5.66436C58.7351 5.81541 58.5458 6.03349 58.4299 6.29143L52.3436 19.3442C52.2569 19.5165 52.2057 19.7044 52.193 19.8968C52.1803 20.0892 52.2064 20.2822 52.2697 20.4643C52.333 20.6465 52.4322 20.814 52.5615 20.9571C52.6908 21.1002 52.8474 21.2158 53.0223 21.2972C53.1971 21.3786 53.3864 21.424 53.5791 21.4308C53.7718 21.4377 53.964 21.4057 54.1441 21.3369C54.3242 21.2681 54.4887 21.1638 54.6277 21.0302C54.7668 20.8966 54.8776 20.7365 54.9536 20.5592L61.0398 7.50924C61.145 7.29203 61.1938 7.05189 61.1819 6.81087C61.17 6.56986 61.0978 6.33569 60.9718 6.12989C60.8458 5.92409 60.6701 5.75325 60.4608 5.63306C60.2516 5.51287 60.0155 5.44719 59.7742 5.44205ZM12.1839 5.44486C11.9467 5.45698 11.7161 5.52761 11.5127 5.65045C11.3094 5.77329 11.1396 5.94452 11.0185 6.1489C10.8974 6.35327 10.8287 6.58443 10.8186 6.82178C10.8084 7.05913 10.8572 7.2953 10.9605 7.50924L17.0467 20.5592C17.1227 20.7365 17.2335 20.8966 17.3726 21.0302C17.5117 21.1638 17.6761 21.2681 17.8562 21.3369C18.0364 21.4057 18.2285 21.4377 18.4212 21.4308C18.6139 21.424 18.8033 21.3786 18.9781 21.2972C19.1529 21.2158 19.3096 21.1002 19.4388 20.9571C19.5681 20.814 19.6673 20.6465 19.7306 20.4643C19.7939 20.2822 19.82 20.0892 19.8073 19.8968C19.7946 19.7044 19.7434 19.5165 19.6567 19.3442L13.5705 6.29143C13.4514 6.02717 13.2553 5.80501 13.008 5.65397C12.7606 5.50293 12.4734 5.43005 12.1839 5.44486ZM36.0002 31.8795C23.6309 31.8795 15.4811 33.5442 10.1617 35.4571C4.84236 37.3699 2.30577 39.6035 1.4261 40.438C0.497441 41.3213 0.340822 42.3761 0.177351 43.5514C0.0138799 44.7267 -0.0186267 46.0589 0.00860106 47.3933C0.0630565 50.0622 0.359988 52.6729 0.562664 53.8255C1.01683 56.4441 2.99916 58.1235 5.08235 57.7517C6.36176 57.5231 17.6914 55.2211 19.3642 54.8127C21.1014 54.3902 22.01 52.8589 22.517 51.193C22.7713 50.3633 23.224 48.4938 23.6477 46.7267C23.9561 45.4403 24.0974 44.8345 24.227 44.2799C25.0712 44.0709 28.098 43.4008 36.0002 43.3995C43.9009 43.3983 46.9296 44.0706 47.7733 44.2799C47.9026 44.8347 48.0418 45.4398 48.3498 46.7267C48.7725 48.4925 49.2244 50.3547 49.4833 51.193C49.9896 52.8529 50.8817 54.4228 52.6614 54.8239C53.396 54.99 56.6119 55.6634 59.8558 56.3342C63.0996 57.0051 66.161 57.636 66.9377 57.763C66.9386 57.763 66.9395 57.763 66.9405 57.763C68.999 58.0976 70.9768 56.4648 71.4405 53.8367C71.4405 53.8358 71.4405 53.8349 71.4405 53.8339C71.641 52.6833 71.9382 50.0679 71.9917 47.3989C72.0185 46.0644 71.9841 44.7352 71.8202 43.5599C71.6563 42.3845 71.5005 41.3265 70.5714 40.4436C69.6927 39.6094 67.1576 37.3746 61.8386 35.4599C56.5196 33.5451 48.3696 31.8795 36.0002 31.8795ZM36.0002 34.7595C48.1108 34.7595 55.9252 36.3937 60.8627 38.1711C65.8001 39.9485 67.8141 41.798 68.5886 42.5333C68.4853 42.4352 68.8393 43.0314 68.9683 43.9564C69.0973 44.8815 69.1366 46.0982 69.1117 47.3399C69.0619 49.8232 68.7563 52.4736 68.6055 53.3389C68.3567 54.7397 67.3276 54.9075 67.4017 54.9195V54.9224C67.0509 54.865 63.6795 54.1831 60.4408 53.5133C57.2021 52.8435 53.8873 52.1477 53.297 52.0142C53.2624 52.0065 52.5685 51.4425 52.2367 50.3549C52.2358 50.353 52.2349 50.3511 52.2339 50.3492C52.068 49.8123 51.5714 47.8132 51.1511 46.0574C50.7308 44.3015 50.3636 42.7133 50.3636 42.7133C50.3055 42.4648 50.1825 42.2362 50.0071 42.0509C49.8316 41.8656 49.6101 41.7302 49.3652 41.6586C49.3652 41.6586 45.3843 40.5181 36.0002 40.5196C26.6135 40.521 22.6352 41.6586 22.6352 41.6586C22.3902 41.7302 22.1687 41.8656 21.9933 42.0509C21.8178 42.2362 21.6948 42.4648 21.6367 42.7133C21.6367 42.7133 21.2701 44.299 20.8492 46.0546C20.4283 47.8101 19.9299 49.8066 19.7636 50.3492C19.7636 50.3502 19.7636 50.3511 19.7636 50.352C19.4352 51.4322 18.7451 51.9993 18.6836 52.0142C18.6836 52.0152 18.6836 52.0161 18.6836 52.017C17.6319 52.2739 5.3271 54.7825 4.5761 54.9167C4.62714 54.9077 3.64469 54.7471 3.40048 53.3333C3.39954 53.3314 3.3986 53.3295 3.39766 53.3277C3.24609 52.4656 2.93645 49.8173 2.88579 47.3342C2.86046 46.0927 2.90056 44.8731 3.02923 43.948C3.15789 43.0229 3.51527 42.4264 3.41173 42.5249C4.18727 41.7892 6.20143 39.9434 11.1377 38.1683C16.0758 36.3926 23.8894 34.7595 36.0002 34.7595Z"
                fill="#00B4FF"
              />
            </svg>
          </div>
          <div className={styles.par_internet_infos}>
            <p className={styles.par_internet_infos_title}>
              {t("Par téléphone")}
            </p>
            <p className={styles.par_internet_infos_text}>
              {t("Horaires d'ouverture")} :
            </p>
            <div className={styles.list}>
              <div className={styles.point} />
              <p className={styles.par_internet_infos_text}>
                {t("En semaine de 9h00 à 18h30")}
              </p>
            </div>

            <a
              rel="noindex,nofollow, noreferrer"
              href="tel:+212520690069"
              className={styles.par_internet_infos_link}
            >
              +212 5 20 69 00 69
            </a>
          </div>
        </div>
        <div className={styles.par_courier}>
          <div className={styles.svg_contacter_container}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className={styles.svg_courier}
              viewBox="0 0 44 58"
              fill="none"
            >
              <path
                d="M21.9987 0.875C10.0174 0.875 0.173438 10.606 0.117188 22.5873C0.173438 27.0873 1.5241 31.475 4.16785 35.1875C4.2241 35.3 4.27947 35.4123 4.39197 35.5248L19.8047 56L19.8607 56.056C20.4232 56.731 21.2112 57.069 21.9987 57.069C22.7862 57.069 23.5741 56.6748 24.1366 56.056L24.1926 56L39.5482 35.5248C39.717 35.356 39.8301 35.2433 39.9426 35.0183C42.4739 31.3621 43.8241 27.031 43.8241 22.5873C43.8241 10.6623 34.0362 0.875 21.9987 0.875ZM21.9987 4.25C32.1799 4.25 40.4491 12.5183 40.4491 22.6433C40.4491 26.4121 39.3239 30.0127 37.1301 33.1627C37.0739 33.219 37.017 33.2746 37.017 33.3308L21.9987 53.3567L7.03638 33.3879L6.98035 33.3308C6.98035 33.2746 6.92344 33.275 6.86719 33.2188C4.67344 30.0688 3.49219 26.4121 3.49219 22.6433C3.54844 12.4621 11.8737 4.25 21.9987 4.25ZM21.9987 11.6185C16.1487 11.6185 11.3672 16.2315 11.3672 21.9127C11.3672 27.594 16.1487 32.2629 21.9987 32.2629C27.8487 32.2629 32.6301 27.65 32.6301 21.9688C32.6301 16.2875 27.8487 11.6185 21.9987 11.6185ZM21.9987 14.9935C25.9924 14.9935 29.2551 18.0877 29.2551 21.9127C29.2551 25.7377 25.9924 28.8879 21.9987 28.8879C18.0049 28.8879 14.7422 25.7938 14.7422 21.9688C14.7422 18.1437 18.0049 14.9935 21.9987 14.9935Z"
                fill="#00B4FF"
              />
            </svg>
          </div>
          <div className={styles.par_internet_infos}>
            <p className={styles.par_internet_infos_title}>
              {t("Par courrier")}
            </p>
            <p className={styles.par_internet_infos_text}>{t("Agenz")}</p>
            <p className={styles.par_internet_infos_text}>{t("Technopark")}</p>
            <p className={styles.par_internet_infos_text}>
              {t("Casablanca, Maroc")}
            </p>
          </div>
        </div>
      </div>
      <ContactForm />
      <div style={{ position: "relative" }}>
        <iframe
          title={t("Localisation de l'agence")}
          width={"100%"}
          height={"450"}
          style={{ border: 0 }}
          src={`https://www.google.com/maps/embed/v1/place?q=${Math.max(
            -7.640322072833155,
            33.54315012417426
          )},${Math.min(
            -7.640322072833155,
            33.54315012417426
          )}&language=${lang}&maptype=${mapsStyle}&key=${GMAPS_API_KEY_IFRAME}&region=MA`}
        ></iframe>

        <div className={style.mapActions}>
          <div className={style.button_map__container}>
            <div className={style.button_map__inner}>
              <div className={style.two_buttons_container}>
                <button
                  data-tracking="click"
                  data-value=""
                  className={style.button}
                  style={
                    twoStyle.first
                      ? { backgroundColor: "#460AF0", color: "white" }
                      : { color: "#460AF0", backgroundColor: "white" }
                  }
                  onClick={() => {
                    setTwoStyle({ ...twoStyle, first: true, second: false });
                    handleChangeMap("roadmap");
                  }}
                >
                  {t("Normal")}
                </button>
                <button
                  className={style.button}
                  style={
                    twoStyle.second
                      ? { backgroundColor: "#460AF0", color: "white" }
                      : { color: "#460AF0", backgroundColor: "white" }
                  }
                  onClick={() => {
                    setTwoStyle({ ...twoStyle, first: false, second: true });
                    handleChangeMap("satellite");
                  }}
                >
                  {t("Satellite")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default contact;
